import { GeneratedMutation } from "@aws-amplify/api-graphql";
import * as APITypes from "~/api/API";

export const createPatientCaseReturningID = `
  mutation CreatePatientCase($input: CreatePatientCaseInput!) {
    createPatientCase(input: $input) {
      id
    }
  }
` as GeneratedMutation<
  APITypes.CreatePatientCaseMutationVariables,
  APITypes.CreatePatientCaseMutation
>;

export const createAppointmentRecordReturningID = `
  mutation CreateAppointmentRecord($input: CreateAppointmentRecordInput!) {
    createAppointmentRecord(input: $input) {
      id
      additionalTimeslots {
        date
        time
        locationID
      }
    }
  }
` as GeneratedMutation<
  APITypes.CreateAppointmentRecordMutationVariables,
  APITypes.CreateAppointmentRecordMutation
>;

export const createAppointmentRecordPatientCaseReturningPairID = `
  mutation CreateAppointmentRecordPatientCase(
    $input: CreateAppointmentRecordPatientCaseInput!
    $condition: ModelAppointmentRecordPatientCaseConditionInput
  ) {
    createAppointmentRecordPatientCase(input: $input, condition: $condition) {
      id
      appointmentRecordId
      patientCaseId
    }
  }
` as GeneratedMutation<
  APITypes.CreateAppointmentRecordPatientCaseMutationVariables,
  APITypes.CreateAppointmentRecordPatientCaseMutation
>;

export const createAppointmentRecordUploadedFileReturningPairID = `
  mutation CreateAppointmentRecordUploadedFile(
      $input: CreateAppointmentRecordUploadedFileInput!
      $condition: ModelAppointmentRecordUploadedFileConditionInput
  ) {
      createAppointmentRecordUploadedFile(input: $input, condition: $condition) {
          id
          appointmentRecordId
          uploadedFileId
      }
  }
`;

export const deleteAppointmentRecordUploadedFileReturningID = `
  mutation DeleteAppointmentRecordUploadedFile(
      $input: DeleteAppointmentRecordUploadedFileInput!
      $condition: ModelAppointmentRecordUploadedFileConditionInput
  ) {
      deleteAppointmentRecordUploadedFile(input: $input, condition: $condition) {
          id
      }
  }
`;

export const updateUploadedFileTypeReturningID = `
  mutation UpdateUploadedFile(
      $input: UpdateUploadedFileInput!
      $condition: ModelUploadedFileConditionInput
  ) {
      updateUploadedFile(input: $input, condition: $condition) {
          id
          key
          type
          provider
          uploadedBy
          uploadedAt
          sourceAppointmentID
          createdAt
          updatedAt
      }
  }
` as GeneratedMutation<
  APITypes.UpdateUploadedFileMutationVariables,
  APITypes.UpdateUploadedFileMutation
>;

export const updateUploadedFileProviderReturningID = `
  mutation UpdateUploadedFile(
      $input: UpdateUploadedFileInput!
      $condition: ModelUploadedFileConditionInput
  ) {
      updateUploadedFile(input: $input, condition: $condition) {
          id
          key
          type
          provider
          uploadedBy
          uploadedAt
          sourceAppointmentID
          createdAt
          updatedAt
      }
  }
` as GeneratedMutation<
  APITypes.UpdateUploadedFileMutationVariables,
  APITypes.UpdateUploadedFileMutation
>;

export const updateUploadedFileFileNameReturningID = `
  mutation UpdateUploadedFile(
      $input: UpdateUploadedFileInput!
      $condition: ModelUploadedFileConditionInput
  ) {
      updateUploadedFile(input: $input, condition: $condition) {
          id
          fileName
      }
  }
` as GeneratedMutation<
  APITypes.UpdateUploadedFileMutationVariables,
  APITypes.UpdateUploadedFileMutation
>;

export const updateAppointmentRecordReturningID = `
  mutation UpdateAppointmentRecord(
    $input: UpdateAppointmentRecordInput!
    $condition: ModelAppointmentRecordConditionInput
  ) {
    updateAppointmentRecord(input: $input, condition: $condition) {
      id
      additionalTimeslots {
        date
        time
        locationID
      }
      panelUnavailable
      panelSpecialty
      videoCallLink
      documentStatus {
        briefingInProgress
        historyInProgress
        __typename
      }
      defenseAttorneyNotPresent
      applicantAttorneyNotPresent
      contactUnavailability {
        patient {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        adjuster {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        applicantAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        defenseAttorney {
          emailUnavailable
          phoneUnavailable
          __typename
        }
        __typename
      }
    }
  }
` as GeneratedMutation<
  APITypes.UpdateAppointmentRecordMutationVariables,
  APITypes.UpdateAppointmentRecordMutation
>;

export const updateAppointmentRecordWithConfig = `
  mutation UpdateAppointmentRecord(
    $input: UpdateAppointmentRecordInput!
    $condition: ModelAppointmentRecordConditionInput
  ) {
    updateAppointmentRecord(input: $input, condition: $condition) {
      id
      reportConfiguration {
        history
        physicalExamination
        assessment
      }
    }
  }
` as GeneratedMutation<
  APITypes.UpdateAppointmentRecordMutationVariables,
  APITypes.UpdateAppointmentRecordMutation
>;

export const updatePatientCaseReturningID = `
  mutation UpdatePatientCase(
    $input: UpdatePatientCaseInput!
    $condition: ModelPatientCaseConditionInput
  ) {
    updatePatientCase(input: $input, condition: $condition) {
      id
    }
  }
` as GeneratedMutation<
  APITypes.UpdatePatientCaseMutationVariables,
  APITypes.UpdatePatientCaseMutation
>;

export const deletePatientCaseReturningID = `
  mutation DeletePatientCase(
    $input: DeletePatientCaseInput!
    $condition: ModelPatientCaseConditionInput
  ) {
    deletePatientCase(input: $input, condition: $condition) {
      id
    }
  }
` as GeneratedMutation<
  APITypes.DeletePatientCaseMutationVariables,
  APITypes.DeletePatientCaseMutation
>;

export const deleteAppointmentRecordPatientCaseReturningID = `
  mutation DeleteAppointmentRecordPatientCase(
    $input: DeleteAppointmentRecordPatientCaseInput!
    $condition: ModelAppointmentRecordPatientCaseConditionInput
  ) {
    deleteAppointmentRecordPatientCase(input: $input, condition: $condition) {
      id
    }
  }
` as GeneratedMutation<
  APITypes.DeleteAppointmentRecordPatientCaseMutationVariables,
  APITypes.DeleteAppointmentRecordPatientCaseMutation
>;

export const updatePatientReturningID = `
  mutation UpdatePatient(
    $input: UpdatePatientInput!
    $condition: ModelPatientConditionInput
  ) {
    updatePatient(input: $input, condition: $condition) {
      id
    }
  }
` as GeneratedMutation<
  APITypes.UpdatePatientMutationVariables,
  APITypes.UpdatePatientMutation
>;

export const createNotesReturningID = `
  mutation CreateNotes(
    $input: CreateNotesInput!
    $condition: ModelNotesConditionInput
  ) {
    createNotes(input: $input, condition: $condition) {
      id
    }
  }
` as GeneratedMutation<
  APITypes.CreateNotesMutationVariables,
  APITypes.CreateNotesMutation
>;

export const deleteAppointmentRecordReturningID = `
  mutation DeleteAppointmentRecord(
    $input: DeleteAppointmentRecordInput!
    $condition: ModelAppointmentRecordConditionInput
  ) {
    deleteAppointmentRecord(input: $input, condition: $condition) {
      id
    }
  }
` as GeneratedMutation<
  APITypes.DeleteAppointmentRecordMutationVariables,
  APITypes.DeleteAppointmentRecordMutation
>;

export const deleteNotesReturningID = `
  mutation DeleteNotes(
    $input: DeleteNotesInput!
    $condition: ModelNotesConditionInput
  ) {
    deleteNotes(input: $input, condition: $condition) {
      id
    }
  }
` as GeneratedMutation<
  APITypes.DeleteNotesMutationVariables,
  APITypes.DeleteNotesMutation
>;

export const updateNotesReturningID = `
  mutation UpdateNotes(
    $input: UpdateNotesInput!
    $condition: ModelNotesConditionInput
  ) {
    updateNotes(input: $input, condition: $condition) {
      id
    }
  }
` as GeneratedMutation<
  APITypes.UpdateNotesMutationVariables,
  APITypes.UpdateNotesMutation
>;

interface CreateUploadedFileMutationOptimized {
  createUploadedFile?: {
    __typename: "UploadedFile";
    id: string;
    key?: string | null;
    type?: APITypes.FileType | null;
    provider?: APITypes.FileProvider | null;
    uploadedBy?: string | null;
    uploadedAt?: string | null;
    createdAt: string;
    updatedAt: string;
  };
}

export const createUploadedFileOptimized = `
  mutation CreateUploadedFile(
    $input: CreateUploadedFileInput!
    $condition: ModelUploadedFileConditionInput
  ) {
    createUploadedFile(input: $input, condition: $condition) {
      id
      key
      type
      provider
      uploadedBy
      uploadedAt
      sourceAppointmentID
      createdAt
      updatedAt
    }
  }
` as GeneratedMutation<
  APITypes.CreateUploadedFileMutationVariables,
  CreateUploadedFileMutationOptimized
>;

export const deleteUploadedFileReturningID = `
  mutation DeleteUploadedFile(
    $input: DeleteUploadedFileInput!
    $condition: ModelUploadedFileConditionInput
  ) {
    deleteUploadedFile(input: $input, condition: $condition) {
      id
      key
      type
      provider
      uploadedBy
      uploadedAt
      createdAt
      updatedAt
    }
  }
` as GeneratedMutation<
  APITypes.DeleteUploadedFileMutationVariables,
  APITypes.DeleteUploadedFileMutation
>;

export const updateDoctorReturningID = `
  mutation UpdateDoctor(
    $input: UpdateDoctorInput!
    $condition: ModelDoctorConditionInput
  ) {
    updateDoctor(input: $input, condition: $condition) {
      id
    }
  }
` as GeneratedMutation<
  APITypes.UpdateDoctorMutationVariables,
  APITypes.UpdateDoctorMutation
>;

export const updateMedicalAssistantReturningID = `
  mutation UpdateMedicalAssistant(
    $input: UpdateMedicalAssistantInput!
    $condition: ModelMedicalAssistantConditionInput
  ) {
    updateMedicalAssistant(input: $input, condition: $condition) {
      id
    }
  }
` as GeneratedMutation<
  APITypes.UpdateMedicalAssistantMutationVariables,
  APITypes.UpdateMedicalAssistantMutation
>;

export const updateMedicalAssistantForOps = `
  mutation UpdateMedicalAssistantForOps(
    $input: UpdateMedicalAssistantInput!
  ) {
    updateMedicalAssistant(input: $input) {
      id
      name
      email
      phoneNumber
      joinedDate
      preVisitCallScheduleLink
      inactive
      languages
      level
      capacityPercent
      roles
      isDemo
      availabilityExceptions {
        type
        during {
          start
          end
        }
        startTime
        endTime
        allDay
      }
      supportedSpecialtyCategories {
        items {
          id
          specialtyCategoryId
          specialtyCategory {
            id
            name
          }
        }
      }
    }
  }
` as GeneratedMutation<
  APITypes.UpdateMedicalAssistantMutationVariables,
  APITypes.UpdateMedicalAssistantMutation
>;

export const createMedicalAssistantForOps = `
  mutation CreateMedicalAssistantForOps(
    $input: CreateMedicalAssistantInput!
  ) {
    createMedicalAssistant(input: $input) {
      id
      name
      email
      phoneNumber
      joinedDate
      preVisitCallScheduleLink
      inactive
      languages
      level
      capacityPercent
      roles
      isDemo
    }
  }
` as GeneratedMutation<
  APITypes.CreateMedicalAssistantMutationVariables,
  APITypes.CreateMedicalAssistantMutation
>;

export const updateLocationReturningID = `
mutation UpdateLocation(
  $input: UpdateLocationInput!
  $condition: ModelLocationConditionInput
) {
  updateLocation(input: $input, condition: $condition) {
      id
    }
  }
` as GeneratedMutation<
  APITypes.UpdateLocationMutationVariables,
  APITypes.UpdateLocationMutation
>;

export const createDoctorReturningID = /* GraphQL */ `mutation CreateDoctor(
  $input: CreateDoctorInput!
  $condition: ModelDoctorConditionInput
) {
  createDoctor(input: $input, condition: $condition) {
    id
  }
}
` as GeneratedMutation<
  APITypes.CreateDoctorMutationVariables,
  APITypes.CreateDoctorMutation
>;

export const createDoctorLocationReturningID =
  /* GraphQL */ `mutation CreateDoctorLocation(
  $input: CreateDoctorLocationInput!
  $condition: ModelDoctorLocationConditionInput
) {
  createDoctorLocation(input: $input, condition: $condition) {
   id
    doctorId
    locationId
  }
}` as GeneratedMutation<
    APITypes.CreateDoctorLocationMutationVariables,
    APITypes.CreateDoctorLocationMutation
  >;

export const updateDoctorLocationReturningID = /* GraphQL */ `
  mutation UpdateDoctorLocation(
    $input: UpdateDoctorLocationInput!
    $condition: ModelDoctorLocationConditionInput
  ) {
    updateDoctorLocation(input: $input, condition: $condition) {
      id
      doctorId
      locationId
    }
  }
` as GeneratedMutation<
  APITypes.UpdateDoctorLocationMutationVariables,
  APITypes.UpdateDoctorLocationMutation
>;

export const deleteDoctorLocationReturningID =
  /* GraphQL */ `mutation DeleteDoctorLocation(
  $input: DeleteDoctorLocationInput!
  $condition: ModelDoctorLocationConditionInput
) {
  deleteDoctorLocation(input: $input, condition: $condition) {
    id
    doctorId
    locationId
    }
  }
` as GeneratedMutation<
    APITypes.DeleteDoctorLocationMutationVariables,
    APITypes.DeleteDoctorLocationMutation
  >;

export const createLocationReturningID = /* GraphQL */ `mutation CreateLocation(
  $input: CreateLocationInput!
  $condition: ModelLocationConditionInput
  ) {
  createLocation(input: $input, condition: $condition) {
    id
    }
  }
` as GeneratedMutation<
  APITypes.CreateLocationMutationVariables,
  APITypes.CreateLocationMutation
>;

export const createDoctorBriefingFieldReturningID =
  /* GraphQL */ `mutation CreateDoctorBriefingField(
  $input: CreateDoctorBriefingFieldInput!
  $condition: ModelDoctorBriefingFieldConditionInput
) {
  createDoctorBriefingField(input: $input, condition: $condition) {
    id
    doctorId
    briefingFieldId
    }
  }
` as GeneratedMutation<
    APITypes.CreateDoctorBriefingFieldMutationVariables,
    APITypes.CreateDoctorBriefingFieldMutation
  >;

export const deleteDoctorBriefingFieldReturningID =
  /* GraphQL */ `mutation DeleteDoctorBriefingField(
  $input: DeleteDoctorBriefingFieldInput!
  $condition: ModelDoctorBriefingFieldConditionInput
) {
  deleteDoctorBriefingField(input: $input, condition: $condition) {
    id
  }
} ` as GeneratedMutation<
    APITypes.DeleteDoctorBriefingFieldMutationVariables,
    APITypes.DeleteDoctorBriefingFieldMutation
  >;

export const createBriefingFieldReturningID =
  /* GraphQL */ `mutation CreateBriefingField(
  $input: CreateBriefingFieldInput!
  $condition: ModelBriefingFieldConditionInput
) {
  createBriefingField(input: $input, condition: $condition) {
    id
  }
} ` as GeneratedMutation<
    APITypes.CreateBriefingFieldMutationVariables,
    APITypes.CreateBriefingFieldMutation
  >;

export const updateBriefingFieldReturningID =
  /* GraphQL */ `mutation UpdateBriefingField(
  $input: UpdateBriefingFieldInput!
  $condition: ModelBriefingFieldConditionInput
) {
  updateBriefingField(input: $input, condition: $condition) {
    id
  }
} ` as GeneratedMutation<
    APITypes.UpdateBriefingFieldMutationVariables,
    APITypes.UpdateBriefingFieldMutation
  >;

export const deleteBriefingFieldReturningID =
  /* GraphQL */ `mutation DeleteBriefingField(
  $input: DeleteBriefingFieldInput!
  $condition: ModelBriefingFieldConditionInput
) {
  deleteBriefingField(input: $input, condition: $condition) {
    id
  }
} ` as GeneratedMutation<
    APITypes.DeleteBriefingFieldMutationVariables,
    APITypes.DeleteBriefingFieldMutation
  >;

export const createAppointmentFilterPresetReturningID =
  /* GraphQL */ `mutation CreateAppointmentFilterPreset(
  $input: CreateAppointmentFilterPresetInput!
  $condition: ModelAppointmentFilterPresetConditionInput
) {
  createAppointmentFilterPreset(input: $input, condition: $condition) {
    id
    name
    filters {
      type
      values
      __typename
    }
    appliesTo
    view
  }
}
` as GeneratedMutation<
    APITypes.CreateAppointmentFilterPresetMutationVariables,
    APITypes.CreateAppointmentFilterPresetMutation
  >;

export const updateAppointmentFilterPresetReturningID =
  /* GraphQL */ `mutation UpdateAppointmentFilterPreset(
  $input: UpdateAppointmentFilterPresetInput!
  $condition: ModelAppointmentFilterPresetConditionInput
) {
  updateAppointmentFilterPreset(input: $input, condition: $condition) {
    id
  }
}
` as GeneratedMutation<
    APITypes.UpdateAppointmentFilterPresetMutationVariables,
    APITypes.UpdateAppointmentFilterPresetMutation
  >;

export const deleteAppointmentFilterPresetReturningID =
  /* GraphQL */ `mutation DeleteAppointmentFilterPreset(
  $input: DeleteAppointmentFilterPresetInput!
  $condition: ModelAppointmentFilterPresetConditionInput
) {
  deleteAppointmentFilterPreset(input: $input, condition: $condition) {
    id
  }
}
` as GeneratedMutation<
    APITypes.DeleteAppointmentFilterPresetMutationVariables,
    APITypes.DeleteAppointmentFilterPresetMutation
  >;

export const createUserAppointmentFilterPresetReturningID =
  /* GraphQL */ `mutation CreateUserAppointmentFilterPreset(
  $input: CreateUserAppointmentFilterPresetInput!
  $condition: ModelUserAppointmentFilterPresetConditionInput
) {
  createUserAppointmentFilterPreset(input: $input, condition: $condition) {
    id
  }
} ` as GeneratedMutation<
    APITypes.CreateUserAppointmentFilterPresetMutationVariables,
    APITypes.CreateUserAppointmentFilterPresetMutation
  >;

export const deleteUserAppointmentFilterPresetReturningID =
  /* GraphQL */ `mutation DeleteUserAppointmentFilterPreset(
  $input: DeleteUserAppointmentFilterPresetInput!
  $condition: ModelUserAppointmentFilterPresetConditionInput
) {
  deleteUserAppointmentFilterPreset(input: $input, condition: $condition) {
    id
  }
} ` as GeneratedMutation<
    APITypes.DeleteUserAppointmentFilterPresetMutationVariables,
    APITypes.DeleteUserAppointmentFilterPresetMutation
  >;

export const updateUserOnboardingDismissals = /* GraphQL */ `
  mutation UpdateUserOnboardingDismissals($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      onboardingDismissals {
        itemId
        dismissedAt
        __typename
      }
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.UpdateUserMutationVariables,
  APITypes.UpdateUserMutation
>;

export const updateUserSettings = /* GraphQL */ `
  mutation UpdateUserSettings($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      settings {
        opsChecklistDefaultExpanded
        __typename
      }
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.UpdateUserMutationVariables,
  APITypes.UpdateUserMutation
>;

export const createCaseSummaryFieldReturningID =
  /* GraphQL */ `mutation CreateCaseSummaryField(
    $input: CreateCaseSummaryFieldInput!
    $condition: ModelCaseSummaryFieldConditionInput
  ) {
    createCaseSummaryField(input: $input, condition: $condition) {
      id
    }
  }
  ` as GeneratedMutation<
    APITypes.CreateCaseSummaryFieldMutationVariables,
    APITypes.CreateCaseSummaryFieldMutation
  >;
export const updateCaseSummaryFieldReturningID =
  /* GraphQL */ `mutation UpdateCaseSummaryField(
    $input: UpdateCaseSummaryFieldInput!
    $condition: ModelCaseSummaryFieldConditionInput
  ) {
    updateCaseSummaryField(input: $input, condition: $condition) {
      id
    }
  }
  ` as GeneratedMutation<
    APITypes.UpdateCaseSummaryFieldMutationVariables,
    APITypes.UpdateCaseSummaryFieldMutation
  >;
export const deleteCaseSummaryFieldReturningID =
  /* GraphQL */ `mutation DeleteCaseSummaryField(
    $input: DeleteCaseSummaryFieldInput!
    $condition: ModelCaseSummaryFieldConditionInput
  ) {
    deleteCaseSummaryField(input: $input, condition: $condition) {
      id
    }
  }
  ` as GeneratedMutation<
    APITypes.DeleteCaseSummaryFieldMutationVariables,
    APITypes.DeleteCaseSummaryFieldMutation
  >;

export const createDoctorCaseSummaryFieldReturningID =
  /* GraphQL */ `mutation CreateDoctorCaseSummaryField(
    $input: CreateDoctorCaseSummaryFieldInput!
    $condition: ModelDoctorCaseSummaryFieldConditionInput
  ) {
    createDoctorCaseSummaryField(input: $input, condition: $condition) {
      id
    }
  }
  ` as GeneratedMutation<
    APITypes.CreateDoctorCaseSummaryFieldMutationVariables,
    APITypes.CreateDoctorCaseSummaryFieldMutation
  >;

export const deleteDoctorCaseSummaryFieldReturningID =
  /* GraphQL */ `mutation DeleteDoctorCaseSummaryField(
    $input: DeleteDoctorCaseSummaryFieldInput!
    $condition: ModelDoctorCaseSummaryFieldConditionInput
  ) {
    deleteDoctorCaseSummaryField(input: $input, condition: $condition) {
      id
    }
  }
  ` as GeneratedMutation<
    APITypes.DeleteDoctorCaseSummaryFieldMutationVariables,
    APITypes.DeleteDoctorCaseSummaryFieldMutation
  >;

export const createDataFieldReturningID =
  /* GraphQL */ `mutation CreateDataField(
  $input: CreateDataFieldInput!
  $condition: ModelDataFieldConditionInput
) {
  createDataField(input: $input, condition: $condition) {
    id
  }
}
` as GeneratedMutation<
    APITypes.CreateDataFieldMutationVariables,
    { createDataField?: { id: string } }
  >;

export const updateDataFieldReturningID =
  /* GraphQL */ `mutation UpdateDataField(
  $input: UpdateDataFieldInput!
  $condition: ModelDataFieldConditionInput
) {
  updateDataField(input: $input, condition: $condition) {
    id
  }
}
` as GeneratedMutation<
    APITypes.UpdateDataFieldMutationVariables,
    { updateDataField?: { id: string } }
  >;

export const deleteDataFieldReturningID =
  /* GraphQL */ `mutation DeleteDataField(
  $input: DeleteDataFieldInput!
  $condition: ModelDataFieldConditionInput
) {
  deleteDataField(input: $input, condition: $condition) {
    id
  }
}
` as GeneratedMutation<
    APITypes.DeleteDataFieldMutationVariables,
    { deleteDataField?: { id: string } }
  >;

export const createDataFieldSectionReturningID =
  /* GraphQL */ `mutation CreateDataFieldSection(
  $input: CreateDataFieldSectionInput!
  $condition: ModelDataFieldSectionConditionInput
) {
  createDataFieldSection(input: $input, condition: $condition) {
    id
  }
}
` as GeneratedMutation<
    APITypes.CreateDataFieldSectionMutationVariables,
    { createDataFieldSection?: { id: string } }
  >;

export const updateDataFieldSectionReturningID =
  /* GraphQL */ `mutation UpdateDataFieldSection(
  $input: UpdateDataFieldSectionInput!
  $condition: ModelDataFieldSectionConditionInput
) {
  updateDataFieldSection(input: $input, condition: $condition) {
    id
  }
}
` as GeneratedMutation<
    APITypes.UpdateDataFieldSectionMutationVariables,
    { updateDataFieldSection?: { id: string } }
  >;

export const deleteDataFieldSectionReturningID =
  /* GraphQL */ `mutation DeleteDataFieldSection(
  $input: DeleteDataFieldSectionInput!
  $condition: ModelDataFieldSectionConditionInput
) {
  deleteDataFieldSection(input: $input, condition: $condition) {
    id
  }
}
` as GeneratedMutation<
    APITypes.DeleteDataFieldSectionMutationVariables,
    { deleteDataFieldSection?: { id: string } }
  >;

export const createCoverLetterRecapReturningID = `
  mutation CreateCoverLetterRecap(
    $input: CreateCoverLetterRecapInput!
    $condition: ModelCoverLetterRecapConditionInput
  ) {
    createCoverLetterRecap(input: $input, condition: $condition) {
      id
    }
  }
` as GeneratedMutation<
  APITypes.CreateCoverLetterRecapMutationVariables,
  APITypes.CreateCoverLetterRecapMutation
>;

export const updateCoverLetterRecapOptimized = `
  mutation UpdateCoverLetterRecap(
    $input: UpdateCoverLetterRecapInput!
    $condition: ModelCoverLetterRecapConditionInput
  ) {
    updateCoverLetterRecap(input: $input, condition: $condition) {
      id
      uploadedFileID
      recapText
      status
      errorMessage
      generatedAt
      lastEditedAt
      lastEditedBy
      createdAt
      updatedAt
    }
  }
` as GeneratedMutation<
  APITypes.UpdateCoverLetterRecapMutationVariables,
  APITypes.UpdateCoverLetterRecapMutation
>;

export const createCoverLetterRecapOptimized = `
  mutation CreateCoverLetterRecap(
    $input: CreateCoverLetterRecapInput!
    $condition: ModelCoverLetterRecapConditionInput
  ) {
    createCoverLetterRecap(input: $input, condition: $condition) {
      id
      uploadedFileID
      recapText
      status
      errorMessage
      generatedAt
      lastEditedAt
      lastEditedBy
      createdAt
      updatedAt
    }
  }
` as GeneratedMutation<
  APITypes.CreateCoverLetterRecapMutationVariables,
  APITypes.CreateCoverLetterRecapMutation
>;

export const deleteCoverLetterRecapOptimized = `
  mutation DeleteCoverLetterRecap(
    $input: DeleteCoverLetterRecapInput!
    $condition: ModelCoverLetterRecapConditionInput
  ) {
    deleteCoverLetterRecap(input: $input, condition: $condition) {
      id
      uploadedFileID
    }
  }
` as GeneratedMutation<
  APITypes.DeleteCoverLetterRecapMutationVariables,
  APITypes.DeleteCoverLetterRecapMutation
>;

export const createIntroParagraphOptimized = `
  mutation CreateIntroParagraph(
    $input: CreateIntroParagraphInput!
    $condition: ModelIntroParagraphConditionInput
  ) {
    createIntroParagraph(input: $input, condition: $condition) {
      id
      appointmentRecordID
      introParagraphText
      sourceRecaps {
        coverLetterRecapID
        uploadedFileID
        recapText
        generatedAt
      }
      status
      errorMessage
      generatedAt
      lastEditedAt
      lastEditedBy
      createdAt
      updatedAt
    }
  }
` as GeneratedMutation<
  APITypes.CreateIntroParagraphMutationVariables,
  APITypes.CreateIntroParagraphMutation
>;

export const updateIntroParagraphOptimized = `
  mutation UpdateIntroParagraph(
    $input: UpdateIntroParagraphInput!
    $condition: ModelIntroParagraphConditionInput
  ) {
    updateIntroParagraph(input: $input, condition: $condition) {
      id
      appointmentRecordID
      introParagraphText
      sourceRecaps {
        coverLetterRecapID
        uploadedFileID
        recapText
        generatedAt
      }
      status
      errorMessage
      generatedAt
      lastEditedAt
      lastEditedBy
      createdAt
      updatedAt
    }
  }
` as GeneratedMutation<
  APITypes.UpdateIntroParagraphMutationVariables,
  APITypes.UpdateIntroParagraphMutation
>;

export const deleteIntroParagraphOptimized = `
  mutation DeleteIntroParagraph(
    $input: DeleteIntroParagraphInput!
    $condition: ModelIntroParagraphConditionInput
  ) {
    deleteIntroParagraph(input: $input, condition: $condition) {
      id
      appointmentRecordID
    }
  }
` as GeneratedMutation<
  APITypes.DeleteIntroParagraphMutationVariables,
  APITypes.DeleteIntroParagraphMutation
>;

// ========================================================================================
// Record Briefing Segment Mutations
// ========================================================================================

/**
 * Create new record briefing segment and return only ID
 */
export const createRecordBriefingSegmentReturningID =
  /* GraphQL */ `mutation CreateRecordBriefingSegment(
  $input: CreateRecordBriefingSegmentInput!
  $condition: ModelRecordBriefingSegmentConditionInput
) {
  createRecordBriefingSegment(input: $input, condition: $condition) {
    id
    __typename
  }
}
` as GeneratedMutation<
    APITypes.CreateRecordBriefingSegmentMutationVariables,
    APITypes.CreateRecordBriefingSegmentMutation
  >;

/**
 * Update record briefing segment and return only ID
 */
export const updateRecordBriefingSegmentReturningID =
  /* GraphQL */ `mutation UpdateRecordBriefingSegment(
  $input: UpdateRecordBriefingSegmentInput!
  $condition: ModelRecordBriefingSegmentConditionInput
) {
  updateRecordBriefingSegment(input: $input, condition: $condition) {
    id
    __typename
  }
}
` as GeneratedMutation<
    APITypes.UpdateRecordBriefingSegmentMutationVariables,
    APITypes.UpdateRecordBriefingSegmentMutation
  >;

/**
 * Delete record briefing segment and return only ID
 */
export const deleteRecordBriefingSegmentReturningID =
  /* GraphQL */ `mutation DeleteRecordBriefingSegment(
  $input: DeleteRecordBriefingSegmentInput!
  $condition: ModelRecordBriefingSegmentConditionInput
) {
  deleteRecordBriefingSegment(input: $input, condition: $condition) {
    id
    __typename
  }
}
` as GeneratedMutation<
    APITypes.DeleteRecordBriefingSegmentMutationVariables,
    APITypes.DeleteRecordBriefingSegmentMutation
  >;

/**
 * Update record briefing segment mapping and return only ID
 */
export const updateRecordBriefingSegmentMappingReturningID =
  /* GraphQL */ `mutation UpdateRecordBriefingSegmentMapping(
  $input: UpdateRecordBriefingSegmentMappingInput!
  $condition: ModelRecordBriefingSegmentMappingConditionInput
) {
  updateRecordBriefingSegmentMapping(input: $input, condition: $condition) {
    id
    draftSegmentID
    __typename
  }
}
` as GeneratedMutation<
    APITypes.UpdateRecordBriefingSegmentMappingMutationVariables,
    APITypes.UpdateRecordBriefingSegmentMappingMutation
  >;

/**
 * Create record briefing segment mapping and return only ID
 */
export const createRecordBriefingSegmentMappingReturningID =
  /* GraphQL */ `mutation CreateRecordBriefingSegmentMapping(
  $input: CreateRecordBriefingSegmentMappingInput!
  $condition: ModelRecordBriefingSegmentMappingConditionInput
) {
  createRecordBriefingSegmentMapping(input: $input, condition: $condition) {
    id
    __typename
  }
}
` as GeneratedMutation<
    APITypes.CreateRecordBriefingSegmentMappingMutationVariables,
    APITypes.CreateRecordBriefingSegmentMappingMutation
  >;

/**
 * Delete record briefing segment mapping and return only ID
 */
export const deleteRecordBriefingSegmentMappingReturningID =
  /* GraphQL */ `mutation DeleteRecordBriefingSegmentMapping(
  $input: DeleteRecordBriefingSegmentMappingInput!
  $condition: ModelRecordBriefingSegmentMappingConditionInput
) {
  deleteRecordBriefingSegmentMapping(input: $input, condition: $condition) {
    id
    __typename
  }
}
` as GeneratedMutation<
    APITypes.DeleteRecordBriefingSegmentMappingMutationVariables,
    APITypes.DeleteRecordBriefingSegmentMappingMutation
  >;

// ========================================================================================
// Record Briefing Lambda Function Mutations
// ========================================================================================

/**
 * Batch update record briefing mappings via Lambda function (bulk delete or discard)
 */
export const batchUpdateRecordBriefingMappingsMutation =
  /* GraphQL */ `mutation BatchUpdateRecordBriefingMappings(
  $recordBriefingId: ID!
  $mappingIds: [ID!]!
  $action: String!
) {
  batchUpdateRecordBriefingMappings(
    recordBriefingId: $recordBriefingId
    mappingIds: $mappingIds
    action: $action
  ) {
    success
    error
    succeededIds
    failedIds
    __typename
  }
}
` as GeneratedMutation<
    APITypes.BatchUpdateRecordBriefingMappingsMutationVariables,
    APITypes.BatchUpdateRecordBriefingMappingsMutation
  >;

export const createInsuranceCarrierReturningID = `
  mutation CreateInsuranceCarrier(
    $input: CreateInsuranceCarrierInput!
    $condition: ModelInsuranceCarrierConditionInput
  ) {
    createInsuranceCarrier(input: $input, condition: $condition) {
      id
      name
      defaultAddressID
      defaultFaxNumberID
      defaultPhoneNumberID
      createdAt
      updatedAt
    }
  }
` as GeneratedMutation<
  APITypes.CreateInsuranceCarrierMutationVariables,
  APITypes.CreateInsuranceCarrierMutation
>;

export const updateInsuranceCarrierReturningID = `
  mutation UpdateInsuranceCarrier(
    $input: UpdateInsuranceCarrierInput!
    $condition: ModelInsuranceCarrierConditionInput
  ) {
    updateInsuranceCarrier(input: $input, condition: $condition) {
      id
      name
      defaultAddressID
      defaultFaxNumberID
      defaultPhoneNumberID
      createdAt
      updatedAt
    }
  }
` as GeneratedMutation<
  APITypes.UpdateInsuranceCarrierMutationVariables,
  APITypes.UpdateInsuranceCarrierMutation
>;

export const deleteInsuranceCarrierReturningID = `
  mutation DeleteInsuranceCarrier(
    $input: DeleteInsuranceCarrierInput!
    $condition: ModelInsuranceCarrierConditionInput
  ) {
    deleteInsuranceCarrier(input: $input, condition: $condition) {
      id
    }
  }
` as GeneratedMutation<
  APITypes.DeleteInsuranceCarrierMutationVariables,
  APITypes.DeleteInsuranceCarrierMutation
>;

export const createLawFirmReturningID = `
  mutation CreateLawFirm(
    $input: CreateLawFirmInput!
    $condition: ModelLawFirmConditionInput
  ) {
    createLawFirm(input: $input, condition: $condition) {
      id
      name
      defaultAddressID
      defaultFaxNumberID
      defaultPhoneNumberID
      createdAt
      updatedAt
    }
  }
` as GeneratedMutation<
  APITypes.CreateLawFirmMutationVariables,
  APITypes.CreateLawFirmMutation
>;

export const updateLawFirmReturningID = `
  mutation UpdateLawFirm(
    $input: UpdateLawFirmInput!
    $condition: ModelLawFirmConditionInput
  ) {
    updateLawFirm(input: $input, condition: $condition) {
      id
      name
      defaultAddressID
      defaultFaxNumberID
      defaultPhoneNumberID
      createdAt
      updatedAt
    }
  }
` as GeneratedMutation<
  APITypes.UpdateLawFirmMutationVariables,
  APITypes.UpdateLawFirmMutation
>;

export const deleteLawFirmReturningID = `
  mutation DeleteLawFirm(
    $input: DeleteLawFirmInput!
    $condition: ModelLawFirmConditionInput
  ) {
    deleteLawFirm(input: $input, condition: $condition) {
      id
    }
  }
` as GeneratedMutation<
  APITypes.DeleteLawFirmMutationVariables,
  APITypes.DeleteLawFirmMutation
>;

export const createStoredAddressReturningID = `
  mutation CreateStoredAddress(
    $input: CreateStoredAddressInput!
    $condition: ModelStoredAddressConditionInput
  ) {
    createStoredAddress(input: $input, condition: $condition) {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
    }
  }
` as GeneratedMutation<
  APITypes.CreateStoredAddressMutationVariables,
  APITypes.CreateStoredAddressMutation
>;

export const updateStoredAddressReturningID = `
  mutation UpdateStoredAddress(
    $input: UpdateStoredAddressInput!
    $condition: ModelStoredAddressConditionInput
  ) {
    updateStoredAddress(input: $input, condition: $condition) {
      id
      street
      city
      state
      zip
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
    }
  }
` as GeneratedMutation<
  APITypes.UpdateStoredAddressMutationVariables,
  APITypes.UpdateStoredAddressMutation
>;

export const deleteStoredAddressReturningID = `
  mutation DeleteStoredAddress(
    $input: DeleteStoredAddressInput!
    $condition: ModelStoredAddressConditionInput
  ) {
    deleteStoredAddress(input: $input, condition: $condition) {
      id
    }
  }
` as GeneratedMutation<
  APITypes.DeleteStoredAddressMutationVariables,
  APITypes.DeleteStoredAddressMutation
>;

export const createStoredFaxNumberReturningID = `
  mutation CreateStoredFaxNumber(
    $input: CreateStoredFaxNumberInput!
    $condition: ModelStoredFaxNumberConditionInput
  ) {
    createStoredFaxNumber(input: $input, condition: $condition) {
      id
      faxNumber
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
    }
  }
` as GeneratedMutation<
  APITypes.CreateStoredFaxNumberMutationVariables,
  APITypes.CreateStoredFaxNumberMutation
>;

export const updateStoredFaxNumberReturningID = `
  mutation UpdateStoredFaxNumber(
    $input: UpdateStoredFaxNumberInput!
    $condition: ModelStoredFaxNumberConditionInput
  ) {
    updateStoredFaxNumber(input: $input, condition: $condition) {
      id
      faxNumber
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
    }
  }
` as GeneratedMutation<
  APITypes.UpdateStoredFaxNumberMutationVariables,
  APITypes.UpdateStoredFaxNumberMutation
>;

export const deleteStoredFaxNumberReturningID = `
  mutation DeleteStoredFaxNumber(
    $input: DeleteStoredFaxNumberInput!
    $condition: ModelStoredFaxNumberConditionInput
  ) {
    deleteStoredFaxNumber(input: $input, condition: $condition) {
      id
    }
  }
` as GeneratedMutation<
  APITypes.DeleteStoredFaxNumberMutationVariables,
  APITypes.DeleteStoredFaxNumberMutation
>;

export const createStoredPhoneNumberReturningID = `
  mutation CreateStoredPhoneNumber(
    $input: CreateStoredPhoneNumberInput!
    $condition: ModelStoredPhoneNumberConditionInput
  ) {
    createStoredPhoneNumber(input: $input, condition: $condition) {
      id
      phoneNumber
      extension
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
    }
  }
` as GeneratedMutation<
  APITypes.CreateStoredPhoneNumberMutationVariables,
  APITypes.CreateStoredPhoneNumberMutation
>;

export const updateStoredPhoneNumberReturningID = `
  mutation UpdateStoredPhoneNumber(
    $input: UpdateStoredPhoneNumberInput!
    $condition: ModelStoredPhoneNumberConditionInput
  ) {
    updateStoredPhoneNumber(input: $input, condition: $condition) {
      id
      phoneNumber
      extension
      insuranceCarrierID
      lawFirmID
      createdAt
      updatedAt
    }
  }
` as GeneratedMutation<
  APITypes.UpdateStoredPhoneNumberMutationVariables,
  APITypes.UpdateStoredPhoneNumberMutation
>;

export const deleteStoredPhoneNumberReturningID = `
  mutation DeleteStoredPhoneNumber(
    $input: DeleteStoredPhoneNumberInput!
    $condition: ModelStoredPhoneNumberConditionInput
  ) {
    deleteStoredPhoneNumber(input: $input, condition: $condition) {
      id
    }
  }
` as GeneratedMutation<
  APITypes.DeleteStoredPhoneNumberMutationVariables,
  APITypes.DeleteStoredPhoneNumberMutation
>;

// ========================================================================================
// Record Briefing Segment Annotation Mutations
// ========================================================================================

/**
 * Create record briefing segment annotation
 */
export const createRecordBriefingSegmentAnnotation = `
  mutation CreateRecordBriefingSegmentAnnotation(
    $input: CreateRecordBriefingSegmentAnnotationInput!
    $condition: ModelRecordBriefingSegmentAnnotationConditionInput
  ) {
    createRecordBriefingSegmentAnnotation(input: $input, condition: $condition) {
      id
      logicalSegmentID
      isStarred
      isImportant
      createdAt
      updatedAt
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.CreateRecordBriefingSegmentAnnotationMutationVariables,
  APITypes.CreateRecordBriefingSegmentAnnotationMutation
>;

/**
 * Update record briefing segment annotation (used for starring/marking
 * segments as important)
 */
export const updateRecordBriefingSegmentAnnotation = `
  mutation UpdateRecordBriefingSegmentAnnotation(
    $input: UpdateRecordBriefingSegmentAnnotationInput!
    $condition: ModelRecordBriefingSegmentAnnotationConditionInput
  ) {
    updateRecordBriefingSegmentAnnotation(input: $input, condition: $condition) {
      id
      logicalSegmentID
      isStarred
      isImportant
      createdAt
      updatedAt
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.UpdateRecordBriefingSegmentAnnotationMutationVariables,
  APITypes.UpdateRecordBriefingSegmentAnnotationMutation
>;

// ========================================================================================
// FieldTemplate Mutations (Phase 2 dual-write mode)
// ========================================================================================

/**
 * Create a new FieldTemplate version
 */
export const createFieldTemplateVersion = `
  mutation CreateFieldTemplate($input: CreateFieldTemplateInput!) {
    createFieldTemplate(input: $input) {
      id
      version
      templateType
      doctorId
      adlFieldSectionMappings {
        ADLFieldSectionID
        ADLFieldIDs
        __typename
      }
      medicalHistoryFieldIDs
      latestMarker
      createdAt
      updatedAt
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.CreateFieldTemplateMutationVariables,
  APITypes.CreateFieldTemplateMutation
>;

/**
 * Update a FieldTemplate (used to remove latestMarker from old versions)
 */
export const updateFieldTemplateRemoveLatestMarker = `
  mutation UpdateFieldTemplate($input: UpdateFieldTemplateInput!) {
    updateFieldTemplate(input: $input) {
      id
      version
      latestMarker
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.UpdateFieldTemplateMutationVariables,
  APITypes.UpdateFieldTemplateMutation
>;

// ========================================================================================
// RecordBriefingSegmentSuggestion Mutations
// ========================================================================================

/**
 * Update a suggestion's status (accept/reject)
 * Returns only the fields needed for status updates
 */
export const updateRecordBriefingSegmentSuggestionStatus = `
  mutation UpdateRecordBriefingSegmentSuggestion(
    $input: UpdateRecordBriefingSegmentSuggestionInput!
  ) {
    updateRecordBriefingSegmentSuggestion(input: $input) {
      id
      status
      resolvedBy
      resolvedAt
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.UpdateRecordBriefingSegmentSuggestionMutationVariables,
  APITypes.UpdateRecordBriefingSegmentSuggestionMutation
>;

/**
 * Update a suggestion's seen state (lightweight mutation for tracking navigation)
 * Returns only the id and seen fields to minimize response payload
 */
export const updateRecordBriefingSegmentSuggestionSeen = `
  mutation UpdateRecordBriefingSegmentSuggestionSeen(
    $input: UpdateRecordBriefingSegmentSuggestionInput!
  ) {
    updateRecordBriefingSegmentSuggestion(input: $input) {
      id
      seen
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.UpdateRecordBriefingSegmentSuggestionMutationVariables,
  APITypes.UpdateRecordBriefingSegmentSuggestionMutation
>;

// ========================================================================================
// OnsiteOpsConfig Mutations
// ========================================================================================

/**
 * Create an OnsiteOpsConfig entry
 * Returns only the essential fields to avoid nested object resolution issues
 */
export const createOnsiteOpsConfigOptimized = `
  mutation CreateOnsiteOpsConfig(
    $input: CreateOnsiteOpsConfigInput!
  ) {
    createOnsiteOpsConfig(input: $input) {
      doctorLocationKey
      onsiteOpsConfigDoctorId
      onsiteOpsConfigLocationId
      onsiteOpsConfigMedicalAssistantId
      onsiteOpsConfigSecondaryMedicalAssistantId
      assignmentEffectiveDate
      createdAt
      updatedAt
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.CreateOnsiteOpsConfigMutationVariables,
  APITypes.CreateOnsiteOpsConfigMutation
>;

/**
 * Update an OnsiteOpsConfig entry
 * Returns only the essential fields to avoid nested object resolution issues
 */
export const updateOnsiteOpsConfigOptimized = `
  mutation UpdateOnsiteOpsConfig(
    $input: UpdateOnsiteOpsConfigInput!
  ) {
    updateOnsiteOpsConfig(input: $input) {
      doctorLocationKey
      onsiteOpsConfigDoctorId
      onsiteOpsConfigLocationId
      onsiteOpsConfigMedicalAssistantId
      onsiteOpsConfigSecondaryMedicalAssistantId
      assignmentEffectiveDate
      createdAt
      updatedAt
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.UpdateOnsiteOpsConfigMutationVariables,
  APITypes.UpdateOnsiteOpsConfigMutation
>;

/**
 * Delete an OnsiteOpsConfig entry
 * Returns only the essential fields to avoid nested object resolution issues
 */
export const deleteOnsiteOpsConfigOptimized = `
  mutation DeleteOnsiteOpsConfig(
    $input: DeleteOnsiteOpsConfigInput!
  ) {
    deleteOnsiteOpsConfig(input: $input) {
      doctorLocationKey
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.DeleteOnsiteOpsConfigMutationVariables,
  APITypes.DeleteOnsiteOpsConfigMutation
>;

// ========================================================================================
// DoctorSupportingMA Mutations (many-to-many join table)
// ========================================================================================

export const createDoctorSupportingMAOptimized = `
  mutation CreateDoctorSupportingMA(
    $input: CreateDoctorSupportingMAInput!
  ) {
    createDoctorSupportingMA(input: $input) {
      id
      doctorId
      medicalAssistantId
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.CreateDoctorSupportingMAMutationVariables,
  APITypes.CreateDoctorSupportingMAMutation
>;

export const deleteDoctorSupportingMAOptimized = `
  mutation DeleteDoctorSupportingMA(
    $input: DeleteDoctorSupportingMAInput!
  ) {
    deleteDoctorSupportingMA(input: $input) {
      id
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.DeleteDoctorSupportingMAMutationVariables,
  APITypes.DeleteDoctorSupportingMAMutation
>;

/**
 * Update RecordBriefing suggestionGeneration status
 * Optimized to return only suggestionGeneration fields
 */
export const updateRecordBriefingSuggestionGeneration = `
  mutation UpdateRecordBriefingSuggestionGeneration(
    $input: UpdateRecordBriefingInput!
  ) {
    updateRecordBriefing(input: $input) {
      id
      suggestionGeneration {
        status
        jobId
        startedAt
        completedAt
        error
      }
    }
  }
` as GeneratedMutation<
  APITypes.UpdateRecordBriefingMutationVariables,
  APITypes.UpdateRecordBriefingMutation
>;

/**
 * Update RecordBriefing editing presence fields.
 * Used to track who is currently editing the briefing.
 */
export const updateRecordBriefingPresence = `
  mutation UpdateRecordBriefingPresence(
    $input: UpdateRecordBriefingInput!
  ) {
    updateRecordBriefing(input: $input) {
      id
      editingPresence
    }
  }
` as GeneratedMutation<
  APITypes.UpdateRecordBriefingMutationVariables,
  APITypes.UpdateRecordBriefingMutation
>;

// ── AppointmentNotification ──

export const updateAppointmentNotificationStatus = `
  mutation UpdateAppointmentNotificationStatus(
    $input: UpdateAppointmentNotificationInput!
  ) {
    updateAppointmentNotification(input: $input) {
      id
      status
      readAt
      updatedAt
    }
  }
` as GeneratedMutation<
  APITypes.UpdateAppointmentNotificationMutationVariables,
  APITypes.UpdateAppointmentNotificationMutation
>;

// ── OpsGlobalSettings ──

export const createOpsGlobalSettingsForOps = `
  mutation CreateOpsGlobalSettingsForOps(
    $input: CreateOpsGlobalSettingsInput!
  ) {
    createOpsGlobalSettings(input: $input) {
      key
      inPersonEvaluationPreVisitDurationDays
      supplementalPreVisitDurationDays
      depositionPreVisitDurationDays
      opsGlobalSettingsDefaultGlobalOnsiteOpsId
      opsGlobalSettingsDefaultGlobalMAId
      opsGlobalSettingsDefaultGlobalSchedulerId
      opsGlobalSettingsDefaultGlobalReportOpsId
      opsGlobalSettingsDefaultGlobalPreVisitReviewerId
      opsGlobalSettingsDefaultGlobalBillingOpsId
      appointmentTypeMAAssignments {
        appointmentType
        maWeights {
          medicalAssistantID
          weightPercentage
        }
      }
      maAssignmentCapacitySettings {
        level1WeeklyPointBudget
        level2WeeklyPointBudget
        level3WeeklyPointBudget
        level4WeeklyPointBudget
        maxAppointmentsPerMAWeek
        maxAppointmentsPerMADay
      }
      bodyPartSpecialtiesMappings {
        bodyPart
        specialties
      }
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.CreateOpsGlobalSettingsMutationVariables,
  APITypes.CreateOpsGlobalSettingsMutation
>;

export const updateOpsGlobalSettingsForOps = `
  mutation UpdateOpsGlobalSettingsForOps(
    $input: UpdateOpsGlobalSettingsInput!
  ) {
    updateOpsGlobalSettings(input: $input) {
      key
      inPersonEvaluationPreVisitDurationDays
      supplementalPreVisitDurationDays
      depositionPreVisitDurationDays
      opsGlobalSettingsDefaultGlobalOnsiteOpsId
      opsGlobalSettingsDefaultGlobalMAId
      opsGlobalSettingsDefaultGlobalSchedulerId
      opsGlobalSettingsDefaultGlobalReportOpsId
      opsGlobalSettingsDefaultGlobalPreVisitReviewerId
      opsGlobalSettingsDefaultGlobalBillingOpsId
      appointmentTypeMAAssignments {
        appointmentType
        maWeights {
          medicalAssistantID
          weightPercentage
        }
      }
      maAssignmentCapacitySettings {
        level1WeeklyPointBudget
        level2WeeklyPointBudget
        level3WeeklyPointBudget
        level4WeeklyPointBudget
        maxAppointmentsPerMAWeek
        maxAppointmentsPerMADay
      }
      bodyPartSpecialtiesMappings {
        bodyPart
        specialties
      }
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.UpdateOpsGlobalSettingsMutationVariables,
  APITypes.UpdateOpsGlobalSettingsMutation
>;

// ── SpecialtyCategory ──

export const createSpecialtyCategoryForOps = `
  mutation CreateSpecialtyCategoryForOps(
    $input: CreateSpecialtyCategoryInput!
  ) {
    createSpecialtyCategory(input: $input) {
      id
      name
      specialties
      specialtyCategoryFallbackMAId
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.CreateSpecialtyCategoryMutationVariables,
  APITypes.CreateSpecialtyCategoryMutation
>;

export const updateSpecialtyCategoryForOps = `
  mutation UpdateSpecialtyCategoryForOps(
    $input: UpdateSpecialtyCategoryInput!
  ) {
    updateSpecialtyCategory(input: $input) {
      id
      name
      specialties
      specialtyCategoryFallbackMAId
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.UpdateSpecialtyCategoryMutationVariables,
  APITypes.UpdateSpecialtyCategoryMutation
>;

export const deleteSpecialtyCategoryForOps = `
  mutation DeleteSpecialtyCategoryForOps(
    $input: DeleteSpecialtyCategoryInput!
  ) {
    deleteSpecialtyCategory(input: $input) {
      id
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.DeleteSpecialtyCategoryMutationVariables,
  APITypes.DeleteSpecialtyCategoryMutation
>;

export const createMaSpecialtyCategoryForOps = `
  mutation CreateMaSpecialtyCategoryForOps(
    $input: CreateMedicalAssistantSpecialtyCategoryInput!
  ) {
    createMedicalAssistantSpecialtyCategory(input: $input) {
      id
      medicalAssistantId
      specialtyCategoryId
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.CreateMedicalAssistantSpecialtyCategoryMutationVariables,
  APITypes.CreateMedicalAssistantSpecialtyCategoryMutation
>;

export const deleteMaSpecialtyCategoryForOps = `
  mutation DeleteMaSpecialtyCategoryForOps(
    $input: DeleteMedicalAssistantSpecialtyCategoryInput!
  ) {
    deleteMedicalAssistantSpecialtyCategory(input: $input) {
      id
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.DeleteMedicalAssistantSpecialtyCategoryMutationVariables,
  APITypes.DeleteMedicalAssistantSpecialtyCategoryMutation
>;
